export const BADGE_PATH = 'https://badgephotos.amazon.com/?uid=';
export const AWS_ROLE_ARN_REGEX =
  /arn:aws:(?<service>\S*):(?<region>\S*):(?<accountId>\d{12}):(?<resourceType>\S+)\/(?<resourceId>\S+)/;
export const AWS_ACCOUNT_ID_REGEX = /^\d{12}$/;
export const LOCALE_SPLIT_TOKEN = ':';
export const DEFAULT_AB_BRANCH_NAME = 'Control';

export const WORKFLOW_STEP_TYPES = {
  AB: 'AB',
  Luma: 'LUMA',
  MachineTranslation: 'MACHINE_TRANSLATION',
  Merge: 'MERGE',
  SegmentAndFilter: 'SEGMENT_AND_FILTER',
  TerminologyBase: 'TERMINOLOGY_BASE',
  TranslationMemory: 'TRANSLATION_MEMORY',
};

export const WORKFLOW_NODE_LABELS = {
  AB: 'Start A/B',
  Luma: 'LLM (Luma)',
  MachineTranslation: 'Machine Translation',
  Merge: 'Merge',
  SegmentAndFilter: 'Segment and Filter',
  TerminologyBase: 'Terminology Base',
  TranslationMemory: 'Translation Memory',
};

export const WORKFLOW_RESOURCE_STEP_TYPES = [
  WORKFLOW_STEP_TYPES.MachineTranslation,
  WORKFLOW_STEP_TYPES.TerminologyBase,
  WORKFLOW_STEP_TYPES.TranslationMemory,
];

/* Email regexes are hard https://www.regular-expressions.info/email.html
 * This one accounts for email eddresses with subdomains, multi-part top-level domains (e.g.: .co.uk), and usernames with plus addressing
 * and also handles most character validation, although as explained above, getting a perfect regex in all these regards is impossible
 */
export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
